import React from 'react';
import { CheckCircle, Phone, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ThankYou() {
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-orange/5 flex flex-col" data-id="element-154">
      {/* Nav */}
      <header className="bg-white border-b border-gray-100 shadow-sm" data-id="element-155">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
          <div className="flex justify-between items-center h-20" data-id="element-157">
            <Link to="/" className="flex-shrink-0" data-id="element-158">
              <img src="https://cdn.magicpatterns.com/uploads/nw66UfUb5KWH6rNxhPmKiS/KEENA-logo-web.png" alt="Keena PEO" className="h-10" data-id="element-159" />
            </Link>
            <a href="tel:5187939825" className="flex items-center text-navy font-semibold hover:text-orange transition-colors" data-id="element-160">
              <Phone className="w-4 h-4 mr-2" data-id="element-161" />
              (518) 793-9825
            </a>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-grow flex items-center justify-center px-4 py-24" data-id="element-162">
        <div className="max-w-xl w-full text-center" data-id="element-163">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-orange/10 rounded-full mb-8" data-id="element-164">
            <CheckCircle className="w-10 h-10 text-orange" data-id="element-165" />
          </div>

          <h1 className="text-4xl sm:text-5xl font-extrabold text-navy mb-6" data-id="element-166">
            Thank You!
          </h1>

          <p className="text-lg sm:text-xl text-gray-600 mb-4 leading-relaxed" data-id="element-167">
            Your message has been received. A member of the Keena team will be
            in touch with you shortly.
          </p>
        </div>
      </main>
    </div>;
}